/**
  * Js Search for top page
*/
const jsSearch = () => {
  const searchInput = document.querySelector('#jsSearchInput') as HTMLInputElement;
  const searchResults = document.querySelector('.jsSearchResults');
  const searchButton = document.querySelector('#jsSearchButton');

  if ( searchInput && searchResults ) {
    searchInput.addEventListener('keyup', function (e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        searchResults.classList.remove('active');
        setTimeout( ()=>{
          searchResults.classList.add('active');
        }, 500);
      }
    });
  }

  if ( searchInput && searchResults && searchButton) {
    searchButton.addEventListener('click', function () {
      searchResults.classList.remove('active');
      setTimeout( ()=>{
        searchResults.classList.add('active');
      }, 500);
    });
  }
};

export default jsSearch;
